import React, { useEffect, useCallback, useState} from 'react';
import ethereum from 'decentralized/ethereum.js';
import {getAllUsers} from 'utils/getAllUsers.js';
import {connect} from 'react-redux';

const ShareWithPeople = ({onSharedWithChanged, guildId}) => { 
    let [value, setValue] = useState('');
    let [shareWith, setShareWith] = useState([]);
    let [users, setUsers] = useState([]);
    let [autoCompletedUsers, setAutoCompletedUsers] = useState([]);

    /*
    useEffect(() => {
        // with the guild id find the users
        if (guildId !== undefined) {
            ethereum.guilds.getUsersInGuild(guildId).then(
                async (users) => {
                    let newMembers = await ethereum.guilds
                        .getNewMemberRequestsFromGuild(guildId);
                    let userNames = [];
                    console.log("USERS = ", users);
                    for (let user of users) {
                        userNames.push(user.userName);
                    }
                    for (let user of newMembers) {
                        userNames.push(await ethereum.users.getUserName(user.newMember));
                    }
                    console.log("user names = ", userNames);
                    let userName = await ethereum.users.getUserName();
                    setShareWith(userNames.filter(n => n !== userName));
                });
        }
    }, [guildId, setShareWith]);
    */

    useEffect(() => {
        // TODO: find out what users have shared before
        // for this project, in order to keep them in the loop
    }, [setShareWith]);

    useEffect(() => {
        onSharedWithChanged(shareWith);
    }, [shareWith]);

    useEffect(() => {
        getAllUsers().then(
            users => setUsers(users));
    }, [setUsers]);

    const addUser = useCallback((user) => {
        setShareWith([... shareWith, user]);
        setValue('');
        setAutoCompletedUsers([]);
    }, [shareWith, setShareWith, setAutoCompletedUsers]);

    const onKeyDown = useCallback((e) => {
        if (e.key === 'Enter') {
            addUser(value);
        }
    }, [setShareWith, value, shareWith, ]);

    useEffect(() => {
        if (value.trim() === "") {
            setAutoCompletedUsers([]);
        } else {
            let auto = users.filter(u => u.userName.toLowerCase().includes(value.toLowerCase()));
            setAutoCompletedUsers(auto);
        }
    }, [value, setAutoCompletedUsers]);

    const deleteUser = useCallback((user) => {
        setShareWith(shareWith.filter(
            u => u !== user));
    }, [setShareWith, shareWith]);

    return (
        <div className="share-with-people">
          <div className="people-input-container">
            {shareWith.map(
                user =>
                    <div className="shared-user">
                      {user}
                      <div
                        onClick={() => deleteUser(user)}
                        className="delete-user">x</div>
                    </div>)}
            <input
              placeholder="Type collaborators to share this with"
              className="people-input"
              value={value}
              type="text"
              onKeyDown={onKeyDown}
              onChange={e => setValue(e.target.value)}/>
          </div>
          <div className="auto-completion-users">
            {autoCompletedUsers.map(
                user => <div
                          onClick={() => addUser(user.userName)}
                          className="auto-completed-user">{user.userName}</div>
            )}
          </div>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShareWithPeople);
